export default __webpack_public_path__ + "static/media/user_down.a7f6c116.svg";